import script from "./Usdt.vue?vue&type=script&setup=true&lang=js"
export * from "./Usdt.vue?vue&type=script&setup=true&lang=js"

import "./Usdt.vue?vue&type=style&index=0&id=3505a38e&lang=less&scoped=true"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3505a38e"]])

export default __exports__